export enum CompareActionTypes {
  addCompareElement = 'addCompareElement',
  removeCompareElement = 'removeCompareElement',
  clearCompareElements = 'clearCompareElements',
}
